import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function InboxIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 24 24'
    >
      <g clipPath='url(#clip0_4842_19023)'>
        <path
          d='M20.79 11.34L17.45 4.66001C17.2006 4.16036 16.8166 3.74026 16.3414 3.44698C15.8661 3.15371 15.3185 2.99891 14.76 3.00001H9.24002C8.68157 2.99891 8.1339 3.15371 7.65865 3.44698C7.18341 3.74026 6.79946 4.16036 6.55002 4.66001L3.21002 11.34C3.07071 11.6195 2.99879 11.9277 3.00002 12.24V18C3.00002 18.7957 3.31609 19.5587 3.8787 20.1213C4.4413 20.6839 5.20437 21 6.00002 21H18C18.7957 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7957 21 18V12.24C21.0012 11.9277 20.9293 11.6195 20.79 11.34ZM8.34002 5.55001C8.42388 5.38357 8.55258 5.24388 8.71161 5.1467C8.87063 5.04952 9.05365 4.99871 9.24002 5.00001H14.76C14.9464 4.99871 15.1294 5.04952 15.2884 5.1467C15.4474 5.24388 15.5762 5.38357 15.66 5.55001L18.38 11H16C15.7348 11 15.4804 11.1054 15.2929 11.2929C15.1054 11.4804 15 11.7348 15 12V15H9.00002V12C9.00002 11.7348 8.89466 11.4804 8.70712 11.2929C8.51959 11.1054 8.26523 11 8.00002 11H5.62002L8.34002 5.55001ZM18 19H6.00002C5.7348 19 5.48045 18.8946 5.29291 18.7071C5.10537 18.5196 5.00002 18.2652 5.00002 18V13H7.00002V16C7.00002 16.2652 7.10537 16.5196 7.29291 16.7071C7.48044 16.8946 7.7348 17 8.00002 17H16C16.2652 17 16.5196 16.8946 16.7071 16.7071C16.8947 16.5196 17 16.2652 17 16V13H19V18C19 18.2652 18.8947 18.5196 18.7071 18.7071C18.5196 18.8946 18.2652 19 18 19Z'
          fill={props.fill ?? '#3B3C40'}
        />
      </g>
      <defs>
        <clipPath id='clip0_4842_19023'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
